import { render, staticRenderFns } from "./getThroughData.vue?vue&type=template&id=15dd4642&scoped=true"
import script from "./getThroughData.vue?vue&type=script&lang=js"
export * from "./getThroughData.vue?vue&type=script&lang=js"
import style0 from "./getThroughData.vue?vue&type=style&index=0&id=15dd4642&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dd4642",
  null
  
)

export default component.exports